var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { DefaultEffector } from './effector/DefaultEffector';
import { DefaultMatcher } from './matcher/DefaultMatcher';
import { DefaultPolicyManager } from './policy/DefaultPolicy';
import { DefaultRequestManager } from './request/DefaultRequest';
var Seraphim = /** @class */ (function () {
    function Seraphim(config, policies) {
        var configure = config.split(/(\n|\r\n)/).reduce(function (pre, c) {
            var _a;
            var d = c.split('=').map(function (w) { return w.trim(); });
            return (__assign({}, pre, (_a = {}, _a[d[0]] = (pre[d[0]] || []).concat(c), _a)));
        }, {});
        this.requestManager = new DefaultRequestManager(configure.r[0]);
        this.policyManager = new DefaultPolicyManager(configure.p[0]);
        if (policies) {
            if (typeof policies === 'string') {
                this.policyManager.addPolicies(policies.split(/(\n|\r\n)/));
            }
            else if (Array.isArray(policies)) {
                this.policyManager.addPolicies(policies);
            }
        }
        this.matcher = new DefaultMatcher(configure.m[0], this.policyManager);
        this.effector = new DefaultEffector(configure.e[0], this.policyManager);
    }
    Seraphim.createInstance = function (config, policies) {
        if (Seraphim._instance) {
            console.warn('Instance has been created.');
        }
        else {
            Seraphim._instance = new Seraphim(config, policies);
        }
        return Seraphim._instance;
    };
    Object.defineProperty(Seraphim, "instance", {
        get: function () {
            if (!Seraphim._instance) {
                throw new Error('Seraphim instance not be created.');
            }
            return Seraphim._instance;
        },
        enumerable: true,
        configurable: true
    });
    Seraphim.prototype.addPolicies = function (policies) {
        if (Array.isArray(policies)) {
            this.policyManager.addPolicies(policies);
        }
        else {
            this.policyManager.addPolicies(policies.split(/(\n|\r\n)/));
        }
    };
    Seraphim.prototype.enforce = function () {
        var request = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            request[_i] = arguments[_i];
        }
        var _a;
        var req = (_a = this.requestManager).getRequestObj.apply(_a, request);
        var matched = this.matcher.match(req);
        var isEffect = this.effector.isEffect(matched);
        return isEffect;
    };
    return Seraphim;
}());
export { Seraphim };
